export function physicianName(
  physician?: {
    family_name: string;
    given_name: string;
  } | null,
) {
  return physician
    ? `${physician.family_name} ${physician.given_name}`
    : undefined;
}
